import React from "react";
import { useTranslation } from "react-i18next";
import HeroSection from "../../components/common/HeroSection";
import PageShell from "../../components/common/PageShell";
import ContactForm from "../../components/contact/ContactForm";
import UAEMap from "../../components/contact/UAEMap";
import { PAGE_HEROES } from "../../constants/pageHeroes";
import { CONTENT_WIDTH } from "../../utils/layout";

function Contact() {
  const { t } = useTranslation();

  return (
    <PageShell>
      <HeroSection {...PAGE_HEROES.contact} variant="page" />
      <section className="caf-section caf-section--elevated caf-page-section">
        <div className={`${CONTENT_WIDTH} caf-page-section__body`}>
          <p className="caf-page-intro">{t("Reach Us")}</p>
          <div className="flex flex-col items-stretch gap-8 md:flex-row md:items-start md:justify-center md:gap-10">
            <UAEMap />
            <ContactForm />
          </div>
        </div>
      </section>
    </PageShell>
  );
}

export default Contact;
